module.exports = __webpack_public_path__ + "static/img/EllysePerry.4504343.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/EllysePerry.jpg
// module id = WQV7
// module chunks = 0